import { Component, Input, OnInit } from '@angular/core';
import { TrustedHtmlString } from '@angular/core/src/sanitization/bypass';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-action',
  templateUrl: './confirm-action.component.html',
  styleUrls: ['./confirm-action.component.scss']
})
export class ConfirmActionComponent implements OnInit {
  @Input() body: string;
  htmlBody: SafeHtml;

  constructor(
    public activeModal: NgbActiveModal,
    protected sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.htmlBody = this.sanitizer.bypassSecurityTrustHtml(this.body);
  }

  confirm() {
    this.activeModal.close('confirm');
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }

}
